import envConfig from './env-config.json';
export const env = envConfig;
if (typeof document !== 'undefined' && !document.getElementById('gs1-wc-fouc-style')) {
    // Scope FOUC rule to gs1-* tags only: a bare `:not(:defined)` would also
    // match third-party custom elements that the host page may legitimately
    // render before/without upgrading (e.g. django-cms `<cms-plugin>`),
    // hiding them indefinitely.
    const tags = [
        'gs1-alert',
        'gs1-badge',
        'gs1-breadcrumb',
        'gs1-button',
        'gs1-card',
        'gs1-chip',
        'gs1-dropdown',
        'gs1-fa-icon',
        'gs1-footer',
        'gs1-graphic-text',
        'gs1-link',
        'gs1-social',
        'gs1-statistic-tile',
        'gs1-testimonial',
    ];
    const selector = tags.map((t) => `${t}:not(:defined)`).join(',');
    const style = document.createElement('style');
    style.id = 'gs1-wc-fouc-style';
    style.textContent = `${selector}{visibility:hidden}`;
    document.head.appendChild(style);
}
//# sourceMappingURL=environment.js.map